import moment from 'moment';
import { useApiQuery } from '../../../../infra/api';
import { endpoints } from '../network';
import { getSessionShop, useSession } from '../../../../infra/session';
import config from '../../../../../config';
export var useAvailableBarberOptions = function (walkInItem) {
    var session = useSession().data;
    var shop = getSessionShop(session);
    var timesheet = useApiQuery({
        endpoint: endpoints.timesheetQuery,
        payload: {
            ownerType: 'shop',
            ownerId: shop.id,
            date: moment(new Date()).format(config.dateFormatISO),
        },
    }).data;
    // Debug logs
    if (typeof window !== 'undefined') {
        console.log('[DEBUG] timesheet', timesheet);
        console.log('[DEBUG] walkInItem.services', walkInItem === null || walkInItem === void 0 ? void 0 : walkInItem.services);
        if (timesheet === null || timesheet === void 0 ? void 0 : timesheet.barbers) {
            timesheet.barbers.forEach(function (barber) {
                console.log('[DEBUG] barber', barber.barber.id, 'assignedServices', barber.barber.assignedServices);
            });
        }
    }
    var availableBarbers = timesheet === null || timesheet === void 0 ? void 0 : timesheet.barbers.filter(function (barber) {
        return walkInItem.services.every(function (walkInItemService) { return barber.barber.assignedServices.includes(walkInItemService.id); });
    }).map(function (barber) { return ({
        value: barber.barber.id,
        label: "".concat(barber.barber.firstName, " ").concat(barber.barber.lastName),
    }); });
    return availableBarbers || [];
};
